module.exports = __webpack_public_path__ + "static/img/approved.846cf6fb.svg";